import React from 'react'
import Index from '../_components/UserHome/Index'

const Home = () => {
  return (
    <Index />
  )
}

export default Home
